export default [
    {
      path: 'relatorios/comissoes',
      name: 'comissoes',
      component: () => import('./index'),
      meta: {
        visible: true,
        title: 'Comissões',
        breadcrumb: [
          { name: 'Home', link: 'home' },
          { name: 'Relatórios', link: 'relatorios' },
          { name: 'Comissões'},
        ]
      }
    }
  ]